(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shpflt-hero"] && !Shopify.designMode) return;
  try {
    
  class ShpfltHero extends ShopigurusHTMLElement {
    /** @type {IntersectionObserver|null} */
    #videoObserver = null;

    connectedCallback() {
      super.connectedCallback();
      this.#setupVideoAutoplay();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.#videoObserver) {
        this.#videoObserver.disconnect();
        this.#videoObserver = null;
      }
    }

    onSectionSelect() {
      this.#pauseAllVideos();
    }

    onSectionDeselect() {
      this.#resumeVisibleVideos();
    }

    #setupVideoAutoplay() {
      const videos = this.querySelectorAll('video[autoplay]');
      if (!videos.length) return;

      this.#videoObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.play().catch(() => {});
            } else {
              entry.target.pause();
            }
          }
        },
        { threshold: 0.25 }
      );

      for (const video of videos) {
        this.#videoObserver.observe(video);
      }
    }

    #pauseAllVideos() {
      const videos = this.querySelectorAll('video');
      for (const video of videos) {
        video.pause();
      }
    }

    #resumeVisibleVideos() {
      const videos = this.querySelectorAll('video[autoplay]');
      for (const video of videos) {
        const rect = video.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        if (inViewport) {
          video.play().catch(() => {});
        }
      }
    }
  }
  customElements.define('shpflt-hero', ShpfltHero);

  } catch(e) { console.error(e); }
})();
})();
